import {cn} from '@chekinapp/ui';
import {SPLASH_TIMING} from './constants';

const CURTAIN_CLASS = cn(
  'pointer-events-none absolute left-0 z-[4] h-[51%] w-full bg-[var(--splash-animation-color)]',
  'transition-transform motion-reduce:transition-none',
);

const CURTAIN_STYLE = {transitionDuration: `${SPLASH_TIMING.curtain}ms`};

function SplashCurtains({areClosed}: {areClosed: boolean}) {
  return (
    <>
      <div
        aria-hidden="true"
        style={CURTAIN_STYLE}
        className={cn(
          CURTAIN_CLASS,
          'top-0',
          areClosed ? 'translate-y-0' : '-translate-y-[101%]',
        )}
      />
      <div
        aria-hidden="true"
        style={CURTAIN_STYLE}
        className={cn(
          CURTAIN_CLASS,
          'bottom-0',
          areClosed ? 'translate-y-0' : 'translate-y-[101%]',
        )}
      />
    </>
  );
}

export {SplashCurtains};
